import { useState, useMemo } from 'react'
import { useAuthStore } from '@/stores/authStore'

// 患者カルテデータ（PatientListと同じデータソース）
const patientRecords = [
  {
    id: 'pat-001',
    researchId: 'R01166',
    name: 'KuKn',
    gender: '女性',
    age: 33,
    diseaseName: '潰瘍性大腸炎',
    transplantCount: 3,
    evaluation: '症状の軽度改善',
    primaryHospitalId: 'hosp-001',
    primaryHospitalName: 'Baseクリニック赤坂',
    primaryDoctorId: 'doc-001',
    primaryDoctorName: '吉岡 紘平',
  },
  {
    id: 'pat-002',
    researchId: 'R01598',
    name: 'ItuHrs',
    gender: '男性',
    age: 38,
    diseaseName: '潰瘍性大腸炎',
    transplantCount: 6,
    evaluation: '症状の中程度の改善',
    primaryHospitalId: 'hosp-004',
    primaryHospitalName: '二子玉川メディカルクリニック',
    primaryDoctorId: 'doc-004',
    primaryDoctorName: '佐藤 健一',
  },
  {
    id: 'pat-003',
    researchId: 'R00500',
    name: 'SymTsk',
    gender: '男性',
    age: 6,
    diseaseName: '自閉スペクトラム症',
    transplantCount: 2,
    evaluation: '症状の軽度改善',
    primaryHospitalId: 'hosp-005',
    primaryHospitalName: '感謝クリニック',
    primaryDoctorId: 'doc-005',
    primaryDoctorName: '田村 一郎',
  },
  {
    id: 'pat-004',
    researchId: 'R01594',
    name: 'FmtHrv',
    gender: '男性',
    age: 4,
    diseaseName: '自閉スペクトラム症',
    transplantCount: 3,
    evaluation: '著効',
    primaryHospitalId: 'hosp-006',
    primaryHospitalName: 'LAGOMクリニック',
    primaryDoctorId: 'doc-006',
    primaryDoctorName: '鈴木 花子',
  },
  {
    id: 'pat-005',
    researchId: 'R01645',
    name: 'YsmrYuk',
    gender: '女性',
    age: 3,
    diseaseName: '自閉スペクトラム症',
    transplantCount: 2,
    evaluation: '症状の軽度改善',
    primaryHospitalId: 'hosp-007',
    primaryHospitalName: 'よろずクリニック',
    primaryDoctorId: 'doc-007',
    primaryDoctorName: '高橋 誠',
  },
  {
    id: 'pat-006',
    researchId: 'R00483',
    name: 'AihrChr',
    gender: '女性',
    age: 51,
    diseaseName: '過敏性腸症候群',
    transplantCount: 2,
    evaluation: '治癒',
    primaryHospitalId: 'hosp-003',
    primaryHospitalName: '城谷バイオウェルネスクリニック',
    primaryDoctorId: 'doc-003',
    primaryDoctorName: '城谷 昌彦',
  },
  {
    id: 'pat-007',
    researchId: 'R01700',
    name: 'KmrMki',
    gender: '女性',
    age: 35,
    diseaseName: 'アトピー性皮膚炎',
    transplantCount: 3,
    evaluation: '著効',
    primaryHospitalId: 'hosp-002',
    primaryHospitalName: 'サンテクリニック',
    primaryDoctorId: 'doc-002',
    primaryDoctorName: '山田 太郎',
  },
  {
    id: 'pat-008',
    researchId: 'R01701',
    name: 'YmdTky',
    gender: '男性',
    age: 48,
    diseaseName: 'うつ病',
    transplantCount: 4,
    evaluation: '症状の中程度の改善',
    primaryHospitalId: 'hosp-001',
    primaryHospitalName: 'Baseクリニック赤坂',
    primaryDoctorId: 'doc-009',
    primaryDoctorName: '佐々木 美咲',
  },
  {
    id: 'pat-009',
    researchId: 'R01702',
    name: 'TnkRk',
    gender: '男性',
    age: 42,
    diseaseName: '潰瘍性大腸炎',
    transplantCount: 5,
    evaluation: '著効',
    primaryHospitalId: 'hosp-003',
    primaryHospitalName: '城谷バイオウェルネスクリニック',
    primaryDoctorId: 'doc-010',
    primaryDoctorName: '木村 大輔',
  },
  {
    id: 'pat-010',
    researchId: 'R01703',
    name: 'SzkHn',
    gender: '女性',
    age: 29,
    diseaseName: '便秘症',
    transplantCount: 2,
    evaluation: '症状の軽度改善',
    primaryHospitalId: 'hosp-008',
    primaryHospitalName: 'シンバイオシス研究所',
    primaryDoctorId: 'doc-008',
    primaryDoctorName: '中川 直哉',
  },
  // 追加のサンプルデータ
  {
    id: 'pat-011',
    researchId: 'R01704',
    name: 'NkmYk',
    gender: '女性',
    age: 28,
    diseaseName: '過敏性腸症候群',
    transplantCount: 3,
    evaluation: '症状の中程度の改善',
    primaryHospitalId: 'hosp-003',
    primaryHospitalName: '城谷バイオウェルネスクリニック',
    primaryDoctorId: 'doc-003',
    primaryDoctorName: '城谷 昌彦',
  },
  {
    id: 'pat-012',
    researchId: 'R01705',
    name: 'TkdMs',
    gender: '男性',
    age: 55,
    diseaseName: '便秘症',
    transplantCount: 2,
    evaluation: '著効',
    primaryHospitalId: 'hosp-001',
    primaryHospitalName: 'Baseクリニック赤坂',
    primaryDoctorId: 'doc-001',
    primaryDoctorName: '吉岡 紘平',
  },
  {
    id: 'pat-013',
    researchId: 'R01706',
    name: 'HrdSk',
    gender: '男性',
    age: 12,
    diseaseName: '自閉スペクトラム症',
    transplantCount: 4,
    evaluation: '症状の中程度の改善',
    primaryHospitalId: 'hosp-005',
    primaryHospitalName: '感謝クリニック',
    primaryDoctorId: 'doc-005',
    primaryDoctorName: '田村 一郎',
  },
  {
    id: 'pat-014',
    researchId: 'R01707',
    name: 'OktYm',
    gender: '女性',
    age: 40,
    diseaseName: 'アトピー性皮膚炎',
    transplantCount: 2,
    evaluation: '症状の軽度改善',
    primaryHospitalId: 'hosp-002',
    primaryHospitalName: 'サンテクリニック',
    primaryDoctorId: 'doc-002',
    primaryDoctorName: '山田 太郎',
  },
  {
    id: 'pat-015',
    researchId: 'R01708',
    name: 'KwtNr',
    gender: '男性',
    age: 33,
    diseaseName: 'うつ病',
    transplantCount: 3,
    evaluation: '変化なし',
    primaryHospitalId: 'hosp-004',
    primaryHospitalName: '二子玉川メディカルクリニック',
    primaryDoctorId: 'doc-004',
    primaryDoctorName: '佐藤 健一',
  },
]

// 診療記録（改善内容・有害事象）
const medicalRecords = [
  { id: 'med-001', patientId: 'pat-001', improvement: '下痢改善', adverseEvent: null },
  { id: 'med-002', patientId: 'pat-001', improvement: '睡眠の改善', adverseEvent: null },
  { id: 'med-003', patientId: 'pat-002', improvement: null, adverseEvent: { type: '腹痛', severity: 'mild', causality: 'possible' } },
  { id: 'med-004', patientId: 'pat-003', improvement: '気分の落ち込みやイライラの改善', adverseEvent: null },
  { id: 'med-005', patientId: 'pat-004', improvement: '気分の落ち込みやイライラの改善', adverseEvent: null },
  { id: 'med-006', patientId: 'pat-005', improvement: '睡眠の改善', adverseEvent: null },
  { id: 'med-007', patientId: 'pat-006', improvement: '便秘改善', adverseEvent: null },
  { id: 'med-008', patientId: 'pat-006', improvement: '下痢改善', adverseEvent: null },
  { id: 'med-009', patientId: 'pat-007', improvement: '皮膚症状の改善', adverseEvent: null },
  { id: 'med-010', patientId: 'pat-008', improvement: '気分の落ち込みやイライラの改善', adverseEvent: null },
  { id: 'med-011', patientId: 'pat-009', improvement: '下痢改善', adverseEvent: null },
  { id: 'med-012', patientId: 'pat-010', improvement: '便秘改善', adverseEvent: null },
  { id: 'med-013', patientId: 'pat-011', improvement: '下痢改善', adverseEvent: { type: '湿疹・肌荒れ', severity: 'mild', causality: 'probable' } },
  { id: 'med-014', patientId: 'pat-012', improvement: '便秘改善', adverseEvent: null },
  { id: 'med-015', patientId: 'pat-013', improvement: '気分の落ち込みやイライラの改善', adverseEvent: null },
  { id: 'med-016', patientId: 'pat-014', improvement: '皮膚症状の改善', adverseEvent: { type: '下痢（軽度）', severity: 'mild', causality: 'definite' } },
  { id: 'med-017', patientId: 'pat-015', improvement: null, adverseEvent: { type: '不眠', severity: 'moderate', causality: 'probable' } },
]

const reportTabs = [
  { id: 'disease', label: '疾患別移植件数' },
  { id: 'doctor', label: '主治医別移植件数' },
  { id: 'results', label: '主治医別移植成績' },
  { id: 'evaluation', label: '全体の移植評価' },
  { id: 'diseaseEval', label: '疾患別移植評価' },
  { id: 'improvement', label: '改善内容一覧' },
  { id: 'adverse', label: '有害事象' },
]

const evaluationColors: Record<string, string> = {
  '治癒': '#10b981',
  '著効': '#22c55e',
  '症状の中程度の改善': '#8b5cf6',
  '症状の軽度改善': '#f97316',
  '変化なし': '#6b7280',
  '症状悪化': '#ef4444',
  '治療の中断': '#3b82f6',
}

const improvementColors: Record<string, string> = {
  '下痢改善': '#06b6d4',
  '便秘改善': '#22c55e',
  '気分の落ち込みやイライラの改善': '#8b5cf6',
  '皮膚症状の改善': '#f97316',
  '睡眠の改善': '#eab308',
  'その他': '#6b7280',
}

export default function Reports() {
  const [activeTab, setActiveTab] = useState('disease')
  const { user } = useAuthStore()

  const isAdminOrOffice = user?.role === 'admin' || user?.role === 'office'
  const userHospitalId = user?.hospitalId

  // 権限に基づいてフィルタリングされた患者データ
  const filteredPatients = useMemo(() => {
    if (isAdminOrOffice) {
      return patientRecords
    }
    return patientRecords.filter(p => p.primaryHospitalId === userHospitalId)
  }, [isAdminOrOffice, userHospitalId])

  // 疾患別移植件数を集計
  const diseaseData = useMemo(() => {
    const counts: Record<string, number> = {}
    filteredPatients.forEach(patient => {
      const disease = patient.diseaseName
      counts[disease] = (counts[disease] || 0) + patient.transplantCount
    })
    return Object.entries(counts)
      .map(([disease, count]) => ({ disease, count }))
      .sort((a, b) => b.count - a.count)
  }, [filteredPatients])

  // 主治医（病院）別移植件数を集計
  const doctorData = useMemo(() => {
    const counts: Record<string, number> = {}
    filteredPatients.forEach(patient => {
      const hospital = patient.primaryHospitalName
      counts[hospital] = (counts[hospital] || 0) + patient.transplantCount
    })
    return Object.entries(counts)
      .map(([doctor, count]) => ({ doctor, count }))
      .sort((a, b) => b.count - a.count)
  }, [filteredPatients])

  // 全体の移植評価を集計
  const evaluationData = useMemo(() => {
    const counts: Record<string, number> = {}
    filteredPatients.forEach(patient => {
      const evaluation = patient.evaluation
      counts[evaluation] = (counts[evaluation] || 0) + 1
    })
    const total = filteredPatients.length
    return Object.entries(counts)
      .map(([evaluation, count]) => ({
        evaluation,
        count,
        percentage: Math.round((count / total) * 1000) / 10,
        color: evaluationColors[evaluation] || '#6b7280',
      }))
      .sort((a, b) => b.count - a.count)
  }, [filteredPatients])

  // 疾患別移植評価を集計
  const diseaseEvalData = useMemo(() => {
    const diseaseStats: Record<string, Record<string, number>> = {}
    
    filteredPatients.forEach(patient => {
      const disease = patient.diseaseName
      const evaluation = patient.evaluation
      
      if (!diseaseStats[disease]) {
        diseaseStats[disease] = {
          '治癒': 0,
          '著効': 0,
          '症状の中程度の改善': 0,
          '症状の軽度改善': 0,
          '変化なし': 0,
          '症状悪化': 0,
        }
      }
      diseaseStats[disease][evaluation] = (diseaseStats[disease][evaluation] || 0) + 1
    })

    return Object.entries(diseaseStats).map(([disease, stats]) => ({
      disease,
      healed: stats['治癒'] || 0,
      effective: stats['著効'] || 0,
      improved: stats['症状の中程度の改善'] || 0,
      mild: stats['症状の軽度改善'] || 0,
      unchanged: stats['変化なし'] || 0,
      worsened: stats['症状悪化'] || 0,
    }))
  }, [filteredPatients])

  // 改善内容を集計
  const improvementData = useMemo(() => {
    const counts: Record<string, number> = {}
    const patientIds = new Set(filteredPatients.map(p => p.id))
    
    medicalRecords
      .filter(record => patientIds.has(record.patientId) && record.improvement)
      .forEach(record => {
        const improvement = record.improvement!
        counts[improvement] = (counts[improvement] || 0) + 1
      })

    const total = Object.values(counts).reduce((a, b) => a + b, 0)
    return Object.entries(counts)
      .map(([content, count]) => ({
        content,
        count,
        percentage: Math.round((count / total) * 1000) / 10,
        color: improvementColors[content] || '#6b7280',
      }))
      .sort((a, b) => b.count - a.count)
  }, [filteredPatients])

  // 有害事象を集計
  const adverseData = useMemo(() => {
    const patientIds = new Set(filteredPatients.map(p => p.id))
    const causalityMap: Record<string, { total: number; events: Record<string, { mild: number; moderate: number; severe: number }> }> = {
      'definite': { total: 0, events: {} },
      'probable': { total: 0, events: {} },
      'possible': { total: 0, events: {} },
      'unlikely': { total: 0, events: {} },
      'none': { total: 0, events: {} },
    }

    const causalityLabels: Record<string, string> = {
      'definite': '明らかに因果関係あり',
      'probable': 'おそらく因果関係あり',
      'possible': '因果関係がある可能性あり',
      'unlikely': '因果関係が考えにくい',
      'none': '因果関係なし',
    }

    medicalRecords
      .filter(record => patientIds.has(record.patientId) && record.adverseEvent)
      .forEach(record => {
        const { type, severity, causality } = record.adverseEvent!
        if (!causalityMap[causality].events[type]) {
          causalityMap[causality].events[type] = { mild: 0, moderate: 0, severe: 0 }
        }
        causalityMap[causality].events[type][severity as 'mild' | 'moderate' | 'severe']++
        causalityMap[causality].total++
      })

    return Object.entries(causalityMap)
      .filter(([, data]) => data.total > 0)
      .map(([causality, data]) => ({
        category: causalityLabels[causality],
        total: data.total,
        events: Object.entries(data.events).map(([event, counts]) => ({
          event,
          ...counts,
        })),
      }))
  }, [filteredPatients])

  const maxCount = Math.max(...diseaseData.map(d => d.count), 1)
  const maxDoctorCount = Math.max(...doctorData.map(d => d.count), 1)

  // 総移植件数
  const totalTransplants = filteredPatients.reduce((sum, p) => sum + p.transplantCount, 0)

  return (
    <>
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          <h1 className="aip-main__header-title">レポート</h1>
          {!isAdminOrOffice && user?.hospitalName && (
            <span className="aip-main__header-subtitle">
              <span className="material-symbols-outlined">local_hospital</span>
              {user.hospitalName}
            </span>
          )}
        </div>
      </header>

      <div className="aip-main__content">
        {/* サマリーカード */}
        <div className="summary-cards">
          <div className="summary-card">
            <span className="summary-card__icon material-symbols-outlined">people</span>
            <div className="summary-card__content">
              <span className="summary-card__value">{filteredPatients.length}</span>
              <span className="summary-card__label">患者数</span>
            </div>
          </div>
          <div className="summary-card">
            <span className="summary-card__icon material-symbols-outlined">medical_services</span>
            <div className="summary-card__content">
              <span className="summary-card__value">{totalTransplants}</span>
              <span className="summary-card__label">総移植件数</span>
            </div>
          </div>
          <div className="summary-card">
            <span className="summary-card__icon material-symbols-outlined">vaccines</span>
            <div className="summary-card__content">
              <span className="summary-card__value">{diseaseData.length}</span>
              <span className="summary-card__label">疾患種類</span>
            </div>
          </div>
          <div className="summary-card">
            <span className="summary-card__icon material-symbols-outlined">trending_up</span>
            <div className="summary-card__content">
              <span className="summary-card__value">
                {Math.round((evaluationData.filter(e => ['治癒', '著効', '症状の中程度の改善', '症状の軽度改善'].includes(e.evaluation)).reduce((sum, e) => sum + e.count, 0) / filteredPatients.length) * 100)}%
              </span>
              <span className="summary-card__label">改善率</span>
            </div>
          </div>
        </div>

        <div className="reports-container">
          {/* タブ */}
          <div className="reports-tabs">
            {reportTabs.map((tab) => (
              <button
                key={tab.id}
                className={`reports-tab ${activeTab === tab.id ? 'reports-tab--active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* コンテンツ */}
          <div className="reports-content">
            {/* 疾患別移植件数 */}
            {activeTab === 'disease' && (
              <div className="report-chart">
                <h2>疾患別移植件数</h2>
                <p className="report-description">
                  患者カルテデータから集計（{filteredPatients.length}名、総移植{totalTransplants}件）
                </p>
                <div className="bar-chart">
                  {diseaseData.map((item) => (
                    <div key={item.disease} className="bar-chart__item">
                      <span className="bar-chart__label">{item.disease}</span>
                      <div className="bar-chart__bar-container">
                        <div
                          className="bar-chart__bar"
                          style={{ width: `${(item.count / maxCount) * 100}%` }}
                        />
                      </div>
                      <span className="bar-chart__value">{item.count}件</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* 主治医別移植件数 */}
            {activeTab === 'doctor' && (
              <div className="report-chart">
                <h2>医療機関別移植件数</h2>
                <p className="report-description">
                  患者カルテの主治医療機関から集計
                </p>
                <div className="bar-chart">
                  {doctorData.map((item) => (
                    <div key={item.doctor} className="bar-chart__item">
                      <span className="bar-chart__label">{item.doctor}</span>
                      <div className="bar-chart__bar-container">
                        <div
                          className="bar-chart__bar bar-chart__bar--secondary"
                          style={{ width: `${(item.count / maxDoctorCount) * 100}%` }}
                        />
                      </div>
                      <span className="bar-chart__value">{item.count}件</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* 主治医別移植成績 */}
            {activeTab === 'results' && (
              <div className="report-chart">
                <h2>医療機関別移植成績</h2>
                <p className="report-description">
                  各医療機関の患者評価結果の割合
                </p>
                <div className="stacked-chart">
                  <div className="stacked-legend">
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#10b981'}}></span>治癒</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#22c55e'}}></span>著効</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#8b5cf6'}}></span>中程度改善</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#f97316'}}></span>軽度改善</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#6b7280'}}></span>変化なし</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#ef4444'}}></span>悪化</span>
                  </div>
                  <div className="stacked-bars">
                    {doctorData.map((item) => {
                      const hospitalPatients = filteredPatients.filter(p => p.primaryHospitalName === item.doctor)
                      const total = hospitalPatients.length || 1
                      const stats = {
                        healed: hospitalPatients.filter(p => p.evaluation === '治癒').length,
                        effective: hospitalPatients.filter(p => p.evaluation === '著効').length,
                        improved: hospitalPatients.filter(p => p.evaluation === '症状の中程度の改善').length,
                        mild: hospitalPatients.filter(p => p.evaluation === '症状の軽度改善').length,
                        unchanged: hospitalPatients.filter(p => p.evaluation === '変化なし').length,
                        worsened: hospitalPatients.filter(p => p.evaluation === '症状悪化').length,
                      }
                      return (
                        <div key={item.doctor} className="stacked-bar-item">
                          <span className="stacked-bar-label">{item.doctor}</span>
                          <div className="stacked-bar">
                            <div style={{width: `${(stats.healed/total)*100}%`, backgroundColor: '#10b981'}} title={`治癒: ${stats.healed}`}></div>
                            <div style={{width: `${(stats.effective/total)*100}%`, backgroundColor: '#22c55e'}} title={`著効: ${stats.effective}`}></div>
                            <div style={{width: `${(stats.improved/total)*100}%`, backgroundColor: '#8b5cf6'}} title={`中程度改善: ${stats.improved}`}></div>
                            <div style={{width: `${(stats.mild/total)*100}%`, backgroundColor: '#f97316'}} title={`軽度改善: ${stats.mild}`}></div>
                            <div style={{width: `${(stats.unchanged/total)*100}%`, backgroundColor: '#6b7280'}} title={`変化なし: ${stats.unchanged}`}></div>
                            <div style={{width: `${(stats.worsened/total)*100}%`, backgroundColor: '#ef4444'}} title={`悪化: ${stats.worsened}`}></div>
                          </div>
                          <span className="stacked-bar-count">{hospitalPatients.length}名</span>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* 全体の移植評価 */}
            {activeTab === 'evaluation' && (
              <div className="report-chart">
                <h2>全体の移植評価</h2>
                <p className="report-description">
                  患者カルテの評価結果から集計（{filteredPatients.length}名）
                </p>
                <div className="pie-chart-container">
                  <div className="pie-chart">
                    <svg viewBox="0 0 200 200">
                      {evaluationData.reduce((acc, item, index) => {
                        const startAngle = acc.angle
                        const sweepAngle = (item.count / filteredPatients.length) * 360
                        const endAngle = startAngle + sweepAngle
                        
                        const startRad = (startAngle - 90) * Math.PI / 180
                        const endRad = (endAngle - 90) * Math.PI / 180
                        
                        const x1 = 100 + 80 * Math.cos(startRad)
                        const y1 = 100 + 80 * Math.sin(startRad)
                        const x2 = 100 + 80 * Math.cos(endRad)
                        const y2 = 100 + 80 * Math.sin(endRad)
                        
                        const largeArc = sweepAngle > 180 ? 1 : 0
                        
                        acc.elements.push(
                          <path
                            key={index}
                            d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`}
                            fill={item.color}
                          />
                        )
                        acc.angle = endAngle
                        return acc
                      }, { elements: [] as React.ReactNode[], angle: 0 }).elements}
                    </svg>
                  </div>
                  <div className="pie-legend">
                    {evaluationData.map((item) => (
                      <div key={item.evaluation} className="pie-legend__item">
                        <span className="pie-legend__color" style={{ backgroundColor: item.color }} />
                        <span className="pie-legend__label">{item.evaluation}</span>
                        <span className="pie-legend__value">{item.count}名 ({item.percentage}%)</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* 疾患別移植評価 */}
            {activeTab === 'diseaseEval' && (
              <div className="report-chart">
                <h2>疾患別移植評価</h2>
                <p className="report-description">
                  疾患ごとの評価結果の内訳
                </p>
                <div className="stacked-chart">
                  <div className="stacked-legend">
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#10b981'}}></span>治癒</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#22c55e'}}></span>著効</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#8b5cf6'}}></span>中程度改善</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#f97316'}}></span>軽度改善</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#6b7280'}}></span>変化なし</span>
                    <span className="legend-item"><span className="legend-color" style={{backgroundColor: '#ef4444'}}></span>悪化</span>
                  </div>
                  <div className="stacked-bars">
                    {diseaseEvalData.map((item) => {
                      const total = item.healed + item.effective + item.improved + item.mild + item.unchanged + item.worsened || 1
                      return (
                        <div key={item.disease} className="stacked-bar-item">
                          <span className="stacked-bar-label">{item.disease}</span>
                          <div className="stacked-bar">
                            <div style={{width: `${(item.healed/total)*100}%`, backgroundColor: '#10b981'}}></div>
                            <div style={{width: `${(item.effective/total)*100}%`, backgroundColor: '#22c55e'}}></div>
                            <div style={{width: `${(item.improved/total)*100}%`, backgroundColor: '#8b5cf6'}}></div>
                            <div style={{width: `${(item.mild/total)*100}%`, backgroundColor: '#f97316'}}></div>
                            <div style={{width: `${(item.unchanged/total)*100}%`, backgroundColor: '#6b7280'}}></div>
                            <div style={{width: `${(item.worsened/total)*100}%`, backgroundColor: '#ef4444'}}></div>
                          </div>
                          <span className="stacked-bar-count">{total}名</span>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* 改善内容一覧 */}
            {activeTab === 'improvement' && (
              <div className="report-chart">
                <h2>改善内容一覧</h2>
                <p className="report-description">
                  診療記録から集計した改善内容
                </p>
                {improvementData.length > 0 ? (
                  <div className="pie-chart-container">
                    <div className="pie-chart">
                      <svg viewBox="0 0 200 200">
                        {improvementData.reduce((acc, item, index) => {
                          const total = improvementData.reduce((sum, i) => sum + i.count, 0)
                          const startAngle = acc.angle
                          const sweepAngle = (item.count / total) * 360
                          const endAngle = startAngle + sweepAngle
                          
                          const startRad = (startAngle - 90) * Math.PI / 180
                          const endRad = (endAngle - 90) * Math.PI / 180
                          
                          const x1 = 100 + 80 * Math.cos(startRad)
                          const y1 = 100 + 80 * Math.sin(startRad)
                          const x2 = 100 + 80 * Math.cos(endRad)
                          const y2 = 100 + 80 * Math.sin(endRad)
                          
                          const largeArc = sweepAngle > 180 ? 1 : 0
                          
                          acc.elements.push(
                            <path
                              key={index}
                              d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`}
                              fill={item.color}
                            />
                          )
                          acc.angle = endAngle
                          return acc
                        }, { elements: [] as React.ReactNode[], angle: 0 }).elements}
                      </svg>
                    </div>
                    <div className="pie-legend">
                      {improvementData.map((item) => (
                        <div key={item.content} className="pie-legend__item">
                          <span className="pie-legend__color" style={{ backgroundColor: item.color }} />
                          <span className="pie-legend__label">{item.content}</span>
                          <span className="pie-legend__value">{item.count}件 ({item.percentage}%)</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="empty-state">
                    <span className="material-symbols-outlined">info</span>
                    <p>改善内容のデータがありません</p>
                  </div>
                )}
              </div>
            )}

            {/* 有害事象 */}
            {activeTab === 'adverse' && (
              <div className="report-chart">
                <h2>有害事象</h2>
                <p className="report-description">
                  診療記録から集計した有害事象と因果関係
                </p>
                {adverseData.length > 0 ? (
                  <div className="cross-table">
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th>移植との因果関係</th>
                          <th>有害事象</th>
                          <th>軽度</th>
                          <th>中度</th>
                          <th>重度</th>
                          <th>小計</th>
                          <th>合計</th>
                        </tr>
                      </thead>
                      <tbody>
                        {adverseData.map((category) => (
                          category.events.map((event, idx) => (
                            <tr key={`${category.category}-${event.event}`}>
                              {idx === 0 && (
                                <td rowSpan={category.events.length} className="category-cell">
                                  {category.category}
                                </td>
                              )}
                              <td>{event.event}</td>
                              <td>{event.mild || '-'}</td>
                              <td>{event.moderate || '-'}</td>
                              <td>{event.severe || '-'}</td>
                              <td>{event.mild + event.moderate + event.severe}</td>
                              {idx === 0 && (
                                <td rowSpan={category.events.length} className="total-cell">
                                  {category.total}
                                </td>
                              )}
                            </tr>
                          ))
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="empty-state">
                    <span className="material-symbols-outlined">check_circle</span>
                    <p>有害事象の報告はありません</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        .aip-main__header-subtitle {
          display: flex;
          align-items: center;
          gap: var(--spacing-xs);
          font-size: 0.875rem;
          color: var(--color-blue600);
          background-color: var(--color-blue50);
          padding: var(--spacing-xs) var(--spacing-sm);
          border-radius: var(--border-radius-md);
          margin-left: var(--spacing-md);
        }

        .aip-main__header-subtitle .material-symbols-outlined {
          font-size: 18px;
        }

        .summary-cards {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: var(--spacing-md);
          margin-bottom: var(--spacing-lg);
        }

        .summary-card {
          display: flex;
          align-items: center;
          gap: var(--spacing-md);
          background-color: var(--background-primary);
          padding: var(--spacing-lg);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .summary-card__icon {
          font-size: 32px;
          color: var(--color-blue500);
          background-color: var(--color-blue50);
          padding: var(--spacing-sm);
          border-radius: var(--border-radius-md);
        }

        .summary-card__content {
          display: flex;
          flex-direction: column;
        }

        .summary-card__value {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--text-primary);
        }

        .summary-card__label {
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .reports-container {
          background-color: var(--background-primary);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .reports-tabs {
          display: flex;
          gap: var(--spacing-xs);
          padding: var(--spacing-md);
          border-bottom: 1px solid var(--border-color);
          overflow-x: auto;
        }

        .reports-tab {
          padding: var(--spacing-sm) var(--spacing-md);
          border: none;
          background: none;
          font-size: 0.875rem;
          color: var(--text-secondary);
          cursor: pointer;
          white-space: nowrap;
          border-radius: var(--border-radius-md);
        }

        .reports-tab:hover {
          background-color: var(--color-solid-gray50);
        }

        .reports-tab--active {
          background-color: var(--color-blue50);
          color: var(--color-blue600);
          font-weight: 500;
        }

        .reports-content {
          padding: var(--spacing-lg);
        }

        .report-chart h2 {
          font-size: 1.125rem;
          font-weight: 600;
          margin-bottom: var(--spacing-xs);
        }

        .report-description {
          font-size: 0.75rem;
          color: var(--text-secondary);
          margin-bottom: var(--spacing-lg);
        }

        .bar-chart {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-sm);
        }

        .bar-chart__item {
          display: grid;
          grid-template-columns: 180px 1fr 60px;
          align-items: center;
          gap: var(--spacing-sm);
        }

        .bar-chart__label {
          font-size: 0.75rem;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .bar-chart__bar-container {
          height: 24px;
          background-color: var(--color-solid-gray100);
          border-radius: var(--border-radius-sm);
        }

        .bar-chart__bar {
          height: 100%;
          background-color: var(--color-blue500);
          border-radius: var(--border-radius-sm);
          transition: width 0.3s ease;
        }

        .bar-chart__bar--secondary {
          background-color: var(--color-blue400);
        }

        .bar-chart__value {
          font-size: 0.75rem;
          font-weight: 500;
        }

        .pie-chart-container {
          display: flex;
          gap: var(--spacing-xl);
          align-items: flex-start;
        }

        .pie-chart {
          width: 200px;
          height: 200px;
          flex-shrink: 0;
        }

        .pie-chart svg {
          width: 100%;
          height: 100%;
        }

        .pie-legend {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-xs);
        }

        .pie-legend__item {
          display: flex;
          align-items: center;
          gap: var(--spacing-sm);
        }

        .pie-legend__color {
          width: 12px;
          height: 12px;
          border-radius: 2px;
          flex-shrink: 0;
        }

        .pie-legend__label {
          font-size: 0.75rem;
          flex: 1;
        }

        .pie-legend__value {
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .stacked-chart {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-md);
        }

        .stacked-legend {
          display: flex;
          flex-wrap: wrap;
          gap: var(--spacing-md);
        }

        .legend-item {
          display: flex;
          align-items: center;
          gap: var(--spacing-xs);
          font-size: 0.75rem;
        }

        .legend-color {
          width: 12px;
          height: 12px;
          border-radius: 2px;
        }

        .stacked-bars {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-sm);
        }

        .stacked-bar-item {
          display: grid;
          grid-template-columns: 180px 1fr 50px;
          align-items: center;
          gap: var(--spacing-sm);
        }

        .stacked-bar-label {
          font-size: 0.75rem;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .stacked-bar {
          display: flex;
          height: 24px;
          border-radius: var(--border-radius-sm);
          overflow: hidden;
        }

        .stacked-bar > div {
          height: 100%;
        }

        .stacked-bar-count {
          font-size: 0.6875rem;
          color: var(--text-secondary);
        }

        .cross-table {
          overflow-x: auto;
        }

        .data-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.75rem;
        }

        .data-table th,
        .data-table td {
          padding: var(--spacing-sm);
          border: 1px solid var(--border-color);
          text-align: center;
        }

        .data-table th {
          background-color: var(--color-solid-gray50);
          font-weight: 500;
        }

        .data-table .category-cell {
          background-color: var(--color-solid-gray25);
          font-weight: 500;
          text-align: left;
        }

        .data-table .total-cell {
          background-color: var(--color-blue50);
          font-weight: 600;
        }

        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: var(--spacing-xl);
          color: var(--text-secondary);
        }

        .empty-state .material-symbols-outlined {
          font-size: 48px;
          margin-bottom: var(--spacing-sm);
          opacity: 0.5;
        }

        @media (max-width: 1024px) {
          .summary-cards {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .summary-cards {
            grid-template-columns: 1fr;
          }

          .bar-chart__item {
            grid-template-columns: 100px 1fr 50px;
          }

          .pie-chart-container {
            flex-direction: column;
          }

          .stacked-bar-item {
            grid-template-columns: 120px 1fr 40px;
          }
        }
      `}</style>
    </>
  )
}
